import Modal from '@web-ui-kit/modal'
import Text from '@web-ui-kit/text'
import i18n from 'i18n'

import { useGlobalModalContext } from 'contexts/GlobalModalContext'
import { isMobile } from 'utils/rebrandingUtils'
import { useWindowDimensions } from 'hooks'

const ModalConfirmHightlight = () => {
  const { store, hideModal } = useGlobalModalContext()
  const { modalProps } = store || {}
  const { body, onCancel, onCancelText, onConfirm, onConfirmText } = modalProps || {}

  const { width: windowWidth } = useWindowDimensions()

  const isFullScreenModal = isMobile(windowWidth)

  return (
    <Modal
      buttons={{
        contained: {
          label: onConfirmText,
          onClick: onConfirm,
        },
        outlined: {
          label: onCancelText,
          onClick: onCancel,
        },
      }}
      handleCloseModal={hideModal}
      isSmall={isFullScreenModal}
      topNav={{
        enableCloseIcon: isFullScreenModal,
        title: isFullScreenModal && i18n.t('Eliminar subrayado'),
      }}
    >
      <Text component='span' variant='body'>
        {body}
      </Text>
    </Modal>
  )
}

export default ModalConfirmHightlight
